document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.mobile-menu-button');
  const menu = document.querySelector('#mobile-menu');
  if (!button || !menu) return;
  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    menu.hidden = expanded;
  });
});